import validate from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.12.2_@libsql+client@0.7.0_@opentelemetry+api@1.9.0_@parcel+watcher@2.4.1_@types+node@2_gm6h4ae3zehumf3jphifg4vvma/node_modules/nuxt/dist/pages/runtime/validate.js";
import reload_45on_45scope_45change_45global from "/opt/buildhome/repo/SSTAlumniAssociation.App/middleware/reload-on-scope-change.global.ts";
export const globalMiddleware = [
  validate,
  reload_45on_45scope_45change_45global
]
export const namedMiddleware = {}